import RsaRiepiloghi from "../index";

const routes = [
  {
    name: "RsaRiepiloghi",
    path: "/rsariepiloghi",
    component: RsaRiepiloghi.RsaRiepiloghiPage,
    meta: { title: "R.S.A. - Riepiloghi" },
  },
];

export default routes;